import { useQuery, useMutation, UseQueryOptions, UseQueryResult } from 'react-query'
import { QueryKeys } from './_query_keys'
import { APIEndpoints } from '../constants/api-endpoints'
import { HttpRequest } from '../services/_http'

export const useGetTools = (searchOptions?: any, options?: UseQueryOptions): UseQueryResult<any> => {
    const method = 'GET'
    const queryKey = [QueryKeys.TOOLS, searchOptions]
    
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: APIEndpoints.Tools,
            params: searchOptions,
            method
        }),
        refetchOnWindowFocus: false,
        keepPreviousData: true,
        ...options
    })
}

export const useGetToolDetail = (
    id: string | number,
    options?: UseQueryOptions
): UseQueryResult<any> => {
    const method = 'GET'
    const queryKey = [QueryKeys.TOOLS, id]

    return useQuery({
        queryKey,
        queryFn: () =>
            HttpRequest({
                url: `${APIEndpoints.Tools}/${id}`,
                method,
            }),
        refetchOnWindowFocus: false,
        enabled: !!id,
        ...options,
    })
}

export const useAddTool = (options?: any) => {
    const method = 'POST'

    return useMutation(
        ({ data }: { data: any }) =>
            HttpRequest({
                url: APIEndpoints.Tools,
                method,
                data,
            }),
        options
    )
}

export const useUpdateTool = (options?: any) => {
    const method = 'PUT'

    return useMutation(
        ({ id, data }: { id: string | number; data: any }) =>
            HttpRequest({
                url: `${APIEndpoints.Tools}/${id}`,
                method,
                data,
            }),
        options
    )
}

export const useStatusTool = (options?: any) => {
    const method = 'PATCH'

    return useMutation(
        ({ id, data }: { id: string | number; data: any }) =>
            HttpRequest({
                url: `${APIEndpoints.Tools}/${id}/status`,
                method,
                data,
            }),
        options
    )
}

export const useDeleteTool = (options?: any) => {
    const method = 'DELETE'

    return useMutation(
        ({ id }: { id: string | number }) =>
            HttpRequest({
                url: `${APIEndpoints.Tools}/${id}`,
                method,
            }),
        options
    )
}
